var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAtencao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73445 21C1.96412 21 1.48306 20.1656 1.86902 19.499L11.1346 3.49482C11.5197 2.82954 12.4803 2.82954 12.8654 3.49483L22.131 19.499C22.5169 20.1656 22.0359 21 21.2656 21H2.73445ZM11.35 14.55C11.35 14.9642 11.6858 15.3 12.1 15.3C12.5142 15.3 12.85 14.9642 12.85 14.55V10.45C12.85 10.0358 12.5142 9.7 12.1 9.7C11.6858 9.7 11.35 10.0358 11.35 10.45V14.55ZM12.1 18.075C12.3167 18.075 12.4958 18.0042 12.6375 17.8625C12.7792 17.7208 12.85 17.5417 12.85 17.325C12.85 17.1083 12.7792 16.9292 12.6375 16.7875C12.4958 16.6458 12.3167 16.575 12.1 16.575C11.8833 16.575 11.7042 16.6458 11.5625 16.7875C11.4208 16.9292 11.35 17.1083 11.35 17.325C11.35 17.5417 11.4208 17.7208 11.5625 17.8625C11.7042 18.0042 11.8833 18.075 12.1 18.075ZM4.4697 17.9987C4.0835 18.6654 4.56454 19.5 5.33499 19.5H18.665C19.4355 19.5 19.9165 18.6654 19.5303 17.9987L12.8653 6.49365C12.4801 5.82868 11.5199 5.82868 11.1347 6.49366L4.4697 17.9987Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtencao);
export default __webpack_public_path__ + "static/media/icon_atencao.06e29f5da99b657eca139570d623fb08.svg";
export { ForwardRef as ReactComponent };